import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
var AuthGuardClientes = /** @class */ (function () {
    function AuthGuardClientes(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    AuthGuardClientes.prototype.canActivate = function () {
        if (this.authService.token && this.authService.roles.indexOf("usuario") > -1) {
            // logged in so return true
            return true;
        }
        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        return false;
    };
    AuthGuardClientes.ctorParameters = function () { return [{ type: Router }, { type: AuthService }]; };
    return AuthGuardClientes;
}());
export { AuthGuardClientes };
//# sourceMappingURL=auth-guard.clientes.js.map


// WEBPACK FOOTER //
// auth-guard.clientes.js